import { Snackbar, Typography } from '@material-ui/core'
import React, { useState } from 'react'
import Layout from '../components/layout/Layout'
import MessageCenter from '../components/MessageCenter'
import MuiAlert from '@material-ui/lab/Alert';

/** «مرکز پیام» — چیدمانِ دوسطونی (گفتگوها + حلقهٔ پیام)، مثلِ مرکز پیامِ ارجان فیش. */
const Messages = () => {
    const [open, setOpen] = useState(false)

    return (
        <Layout>
            <MessageCenter />

            <Snackbar open={open} autoHideDuration={6000} onClose={() => setOpen(false)}>
                <MuiAlert elevation={6} onClose={() => setOpen(false)} variant='filled' severity='success'>
                    <Typography>
                        پیام با موفقیت ارسال شد.
                    </Typography>
                </MuiAlert>
            </Snackbar>
        </Layout>
    )
}
export default Messages
